import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import PromoCode from '../../../smoothr-web-app-core/models/PromoCode';

@Component({
	selector: 'app-promo-code',
	templateUrl: './promo-code.component.html',
	styleUrls: ['promo-code.component.scss'],
	standalone: false,
})
export class PromoCodeComponent implements OnInit, OnDestroy {
	@Input()
	promoCode: PromoCode;
	@Output()
	onRemoveClick = new EventEmitter<PromoCode>();

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit() {}

	ngOnDestroy() {}

	onRemoveClickHandler() {
		this.onRemoveClick.emit(this.promoCode);
	}
}
